import React from 'react';
import ImageViewer from './ImageViewer';
import PDFViewer from './PDFViewer';

const FileViewer = ({ file, isOpen, onClose }) => {
  if (!file) return null;

  const getFileType = (filename) => {
    const extension = filename?.toLowerCase().split('.').pop();
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
      return 'image';
    } else if (extension === 'pdf') {
      return 'pdf';
    }
    return 'unknown';
  };

  const fileType = getFileType(file.filename || file.name);

  if (fileType === 'image') {
    return (
      <ImageViewer
        isOpen={isOpen}
        onClose={onClose}
        imageUrl={file.url}
        filename={file.filename || file.name}
      />
    );
  }

  if (fileType === 'pdf') {
    return (
      <PDFViewer
        isOpen={isOpen}
        onClose={onClose}
        pdfUrl={file.url}
        filename={file.filename || file.name}
      />
    );
  }

  // For unsupported file types, show a download modal
  return (
    <div
      className={`fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-60 flex items-start justify-center p-4 ${
        isOpen ? '' : 'hidden'
      }`}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900">
            File: {file.filename || file.name}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>

          <div>
            <p className="text-gray-600 mb-4">
              This file type cannot be previewed. You can download it to view with an appropriate application.
            </p>

            <div className="flex space-x-3 justify-center">
              <button
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = file.url;
                  link.download = file.filename || file.name || 'download';
                  link.target = '_blank';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                className="btn-primary flex items-center space-x-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span>Download</span>
              </button>

              <button
                onClick={onClose}
                className="border border-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-50"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileViewer;
